const aside = {
	el: {
		header: document.querySelector('header'),
		aside: document.querySelector('.aside'),
		asideStickyItemCopy: document.querySelector('.aside__item-sticky-copy'),
		asideScrollItem: document.querySelectorAll('.aside__item[data-scroll]'),
		asideToggleMobile: document.querySelector('.js-toggle-aside'),
		articles: document.querySelectorAll('.js-article')
	},

	vars: {
		extraLargeAndUp: window.matchMedia('(min-width: 80em)')
	},

	fxAsideSetActive(element, index) {
		const asideHalfHeight = this.el.aside.offsetHeight / 2

		if (window.pageYOffset >= element.offsetTop - this.el.header.offsetHeight - (this.el.asideToggleMobile && !this.vars.extraLargeAndUp.matches ? this.el.asideToggleMobile.offsetHeight : asideHalfHeight)) {
			this.el.asideScrollItem.forEach(el => el.classList.remove('is-active'))
			if (this.el.asideScrollItem[index])
				this.el.asideScrollItem[index].classList.add('is-active')

			if (!this.vars.extraLargeAndUp.matches)
				this.el.asideStickyItemCopy.textContent = document.querySelector('.aside__item.is-active').textContent
		}
	},

	fxSetMobileText() {
		this.el.asideStickyItemCopy.textContent = this.el.asideScrollItem[0].textContent
	},

	events() {
		if (this.el.asideScrollItem.length > 1) {
			this.el.asideToggleMobile.parentElement.classList.add('is-list')
			this.el.asideToggleMobile.addEventListener('click', e => {
				e.currentTarget.parentElement.classList.toggle('is-aside-open')
				this.el.asideStickyItemCopy.textContent = document.querySelector('.aside__item.is-active') ? document.querySelector('.aside__item.is-active').textContent : ''
			})
		}
		else {
			this.el.asideToggleMobile.classList.add('d-none')
		}

		this.el.articles.forEach((el, i) => window.addEventListener('load', e => e.currentTarget.addEventListener('scroll', () => this.fxAsideSetActive(el, i))))
	},

	init() {
		if (!this.el.aside) return
		this.fxSetMobileText()
		this.events()
	}
}

aside.init()